import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-consumption-place-electric',
  templateUrl: './consumption-place-electric.component.html'
})
export class ConsumptionPlaceElectricComponent implements OnInit {

  public consumptionPlaceForm: FormGroup;
  public consumptionPlaceAddress: string = "Adresa loc de consum";
  public networkOperator: string = "Operator de retea";
  public pod: string = "POD";
  public serviceContract: string = "Modul de contractare al serviciului de retea";
  public contractType: string = "Tip contract";
  public contractNo: string = "Numar contract";
  public contractDate: string = "Data contract";
  public conventionType: string = "Tip conventie";
  public conventionNo: string = "Numar conventie";
  public conventionDate: string = "Data conventie";
  public conventionParties: string = "Parti conventie";
  public conventionExists: string = "Exista conventie?";
  public multipleSuppliers: string = "Exista mai multi furnizori";
  public number: string = "Numar";
  public date: string = "Data";
  public technicalConnectionApproval: string = "Aviz tehnic de racordare";
  public connectionCertificate: string = "Certificat racordare";
  public voltageLevel: string = "Nivel de tensiune (V)";
  public approvedPower: string = "Puterea aprobata (V)";
  public connectionType: string = "Tip racord";
  public networkType: string = "Tip retea";
  public counterType: string = "Tip contor";
  public counterSeries: string = "Serie contor";
  public intelligentMeasurementSystem: string = "Exista un sistem de masurare inteligent";
  public yes: string = "DA";
  public no: string = "NU";
  public tripartite: string = "Tripartita";
  public multipart: string = "Multipartita";
  public connected: string = "Conectat";
  public disconnected: string = "Deconectat";
  public distribution: string = "Distributie";
  public transport: string = "Transport";
  public consumptionPlaceStatus: string = "Status loc de consum";
  public throughSupplier: string = "Prin furnizor";
  public directly: string = "Direct";
  public monoPhase: string = "Monofazat";
  public triPhase: string = "Trifazat";
  public prosumerQuality: string = "Are calitatea de prosumator?";
  public indexReadingFrequency: string = "Periodicitate citire index(luni)";

  constructor(private formBuilder: FormBuilder) {
    this.createConsumptionForm();
  }

  ngOnInit(): void {
  }

  createConsumptionForm(): void {
    this.consumptionPlaceForm = this.formBuilder.group({

    })
  }

}
